import { useState } from 'react'
import { HiOutlineInformationCircle, HiX, HiExclamation } from 'react-icons/hi'
import Button from 'components/Button'
import Modal from 'components/Modal'

export default function LedgerModal({ onDismiss }: { onDismiss: () => void }) {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <div className="rounded-md bg-gray-50 p-4 mt-8 md:max-w-lg border-2 border-red-500">
        <div className="flex justify-center items-center">
          <HiExclamation className="h-7 w-7 text-red-500" />
          <div className="ml-3 flex-1 text-sm text-gray-500">
            <p>
              <span className="font-bold">Do not mint with an account connected to Ledger</span>.
              Ledger hardware wallets are currently not supported.
            </p>
            <a role="button" className="font-semibold underline" onClick={() => setIsOpen(true)}>
              More info
            </a>
          </div>
          <div className="ml-auto pl-3">
            <div className="-mx-1.5 -my-1.5">
              <button
                type="button"
                className="inline-flex bg-gray-50 rounded-md p-1.5 text-gray-400 hover:bg-gray-100 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-50 focus:ring-gray-600"
                onClick={onDismiss}
              >
                <span className="sr-only">Dismiss</span>
                <HiX className="h-5 w-5" aria-hidden="true" />
              </button>
            </div>
          </div>
        </div>
      </div>
      <Modal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        title="Ledger Support"
        icon={HiOutlineInformationCircle}
      >
        <div className="text-sm text-gray-600 space-y-6 mt-6">
          <p>
            Minting an NFD on a Ledger hardware wallet is not supported at this time. This is due to
            current limitations of the Ledger software.
          </p>
          <p>You can, however, link a Ledger wallet to an NFD that you have already minted.</p>
          <p>
            We will make an announcement on our social channels as soon as Ledger support changes.
          </p>
        </div>
        <div className="space-x-2 mt-6 flex justify-end">
          <Button onClick={() => setIsOpen(false)}>Close</Button>
        </div>
      </Modal>
    </>
  )
}
